<html>

    <body class="dx-viewport">
      
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->  
        <dx-box
            direction="row"
            width="100%"
            [height]="formheight"
        >

            <dxi-item
                [ratio]="1.5"
            >
                <dx-box
                    direction="col"
                    width="100%"
                    height="100%"
                >
                    <!----------------------------------------------------------------------------------------------->
                    <dxi-item
                        class="rectangleinfosquare"
                        [ratio]="8"
                    >
                        <!----------------------------------------------------------------------------------------------->
                        <dx-select-box 
                            [dataSource]="this.whoseguest" 
                            valueExpr="id" 
                            displayExpr="fullname"
                            (onItemClick)="buildstats($event)"
                        >
                        </dx-select-box>
                        <!----------------------------------------------------------------------------------------------->
                        <dx-chart
                            #barinviteechart
                            id="barinviteechart"
                            
                            [dataSource]="barchart"
                            [rotated]="true"
                            height="100%"

                            [animation]="false"

                            [customizePoint]="customizePoint"
                            (onPointClick)="onPointClick($event)"
                            (onPointHoverChanged)="onPointHoverChanged($event)"
                        >
                            <!----------------------------------------------------------------------------------------------->
                            <dxi-series                        
                                name="Not Coming"
                                valueField="notcoming" 
                                tag="5"
                                color="#ff3300"
                            >
                            </dxi-series>     <!---Order 5--->  
                            
                            <dxi-series                        
                                name="Coming"
                                valueField="coming" 
                                tag="4"
                                color="#33cc33"
                            >
                            </dxi-series>     <!---Order 4--->  

                            <dxi-series 
                                name="Undecided"
                                valueField="undecided" 
                                tag="3"
                                color="#cc9900"
                            >
                            
                            </dxi-series>     <!---Order 3--->

                            <dxi-series 
                                name="Invited"
                                valueField="invitedactual" 
                                tag="2"
                                color="#3333ff"
                            >
                            </dxi-series>     <!---Order 2--->

                            <dxi-series
                                name="Estimate" 
                                valueField="invitedbudget"
                                tag="1"
                                color="#8c1aff"
                            >
                            </dxi-series>   <!---Order 1--->
                            <!----------------------------------------------------------------------------------------------->
                            <dxo-title
                                text="Invitee Status"
                                subtitle=""
                            >

                                <dxo-font
                                    size="14"
                                >
                                </dxo-font>
                                
                            </dxo-title>
                            <!----------------------------------------------------------------------------------------------->
                            <dxo-common-series-settings
                            
                                type="bar"
                                argumentField="eventparticipant"
                                
                                hoverMode="allArgumentPoints"
                                selectionMode="allArgumentPoints"

                                [minBarSize]="10"
                            >

                                <dxo-label
                                    [visible]="true"
                                    [format]=" {
                                                type: 'fixedPoint',
                                                precision: 0
                                            }"
                                >
                                </dxo-label> 

                                <dxo-point>

                                    <dxo-hover-style
                              
                                    >
                                    </dxo-hover-style>


                                </dxo-point>

                            </dxo-common-series-settings>
                            <!----------------------------------------------------------------------------------------------->
                            <dxo-legend 
                                [visible]="true"
                                position="outside"
                                horizontalAlignment="left"
                                verticalAlignment="bottom"
                                orientation="horizontal"

                                [customizeItems]="orderLegendItems"
                            
                            >
                            </dxo-legend>
                            <!----------------------------------------------------------------------------------------------->
                            <dxi-value-axis 
                                [showZero]="false"
                                [valueMarginsEnabled]="true"
                                [maxValueMargin]="0.05"
                            >
                                <dxo-grid [visible]="true"></dxo-grid>
                                <dxo-title text="No. Persons"></dxo-title>
                            </dxi-value-axis>
                            <!----------------------------------------------------------------------------------------------->
                            <dxo-argument-axis
                            >
                                <dxo-label [visible]="false"></dxo-label>
                            </dxo-argument-axis>
                            <!-----------------------------------------------------------------------------------------------> 
                        </dx-chart>

                    </dxi-item>
                    <!----------------------------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="0.1"
                    >
                   
                    </dxi-item>
                    <!----------------------------------------------------------------------------------------------->
                    <dxi-item
                        class="rectangleinfosquare"
                        [ratio]="3.5"
                    >
                        <dx-select-box 
                            [dataSource]="barchartdropdownlist" 
                            valueExpr="id" 
                            displayExpr="chartname"
                            [visible]="selectboxdashother"
                
                            (onItemClick)="xxxx($event)"
                        ></dx-select-box>

                        <dx-chart
                            #chartOther
                            id="chartOther"
                            
                            [dataSource]="barchart"
                            [rotated]="true"

                            [animation]="false"
                           
                            [customizePoint]="customizePoint"
                            (onPointClick)="onPointClick($event)"
                            (onPointHoverChanged)="onPointHoverChanged($event)"
                        >
                            <!----------------------------------------------------------------------------------------------->
                            <ng-template [ngIf]="seriescnt == 1">

                                <dxi-series
                                    [name]="seriesname1" 
                                    [valueField]="seriesname1value"
                                    [tag]="seriesname1tag"
                                >
                                </dxi-series>   <!---Order 1--->

                            </ng-template>   
                            <!----------------------------------------------------------------------------------------------->
                            <ng-template [ngIf]="seriescnt == 2">

                                <dxi-series 
                                    [name]="seriesname2" 
                                    [valueField]="seriesname2value"
                                    [tag]="seriesname2tag"
                                    color="#c90076"
                                >
                                </dxi-series>     <!---Order 2--->

                                
                                <dxi-series
                                    [name]="seriesname1" 
                                    [valueField]="seriesname1value"
                                    [tag]="seriesname1tag"
                                >
                                </dxi-series>   <!---Order 1--->

                            </ng-template>
                            <!----------------------------------------------------------------------------------------------->
                            <ng-template [ngIf]="seriescnt == 3">

                                <dxi-series 
                                    [name]="seriesname3" 
                                    [valueField]="seriesname3value"
                                    [tag]="seriesname3tag"
                                    color="#33cc33"
                                >
                                </dxi-series>     <!---Order 3--->

                                <dxi-series 
                                    [name]="seriesname2" 
                                    [valueField]="seriesname2value"
                                    [tag]="seriesname2tag"
                                    color="#cc9900"
                                >
                                </dxi-series>     <!---Order 2--->

                                
                                <dxi-series
                                    [name]="seriesname1" 
                                    [valueField]="seriesname1value"
                                    [tag]="seriesname1tag"
                                    color="#8c1aff"
                                >
                                </dxi-series>   <!---Order 1--->

                            </ng-template>
                            <!----------------------------------------------------------------------------------------------->
                            <dxo-title
                                [text]="charttitle"
                            >

                                <dxo-font
                                    size="14"
                                >
                                </dxo-font>

                            </dxo-title>
                            <!----------------------------------------------------------------------------------------------->
                            <dxo-common-series-settings
                            
                                type="bar"
                                argumentField="eventparticipant"
                                
                                hoverMode="allArgumentPoints"
                                selectionMode="allArgumentPoints"

                                [minBarSize]="10"
                            >

                                <dxo-label
                                    [visible]="true"
                                    [format]=" {
                                                type: 'fixedPoint',
                                                precision: 0
                                            }"
                                >
                                </dxo-label> 

                            </dxo-common-series-settings>
                            <!----------------------------------------------------------------------------------------------->
                            <dxo-legend 
                                [visible]="true"   
                                [customizeItems]="orderLegendOtherItems"  
                            >
                            </dxo-legend>
                            <!----------------------------------------------------------------------------------------------->
                            <dxi-value-axis 
                                [showZero]="false"
                                [valueMarginsEnabled]="true"
                                [maxValueMargin]="0.05"
                            >
                                <dxo-grid [visible]="true"></dxo-grid>
                                <dxo-title text="No. Persons"></dxo-title>
                            </dxi-value-axis>
                            <!----------------------------------------------------------------------------------------------->
                            <dxo-argument-axis
                            >
                                <dxo-label [visible]="false"></dxo-label>
                            </dxo-argument-axis>
                            <!-----------------------------------------------------------------------------------------------> 
                        </dx-chart>
                       

                    </dxi-item>
                    <!----------------------------------------------------------------------------------------------->

                </dx-box>

            </dxi-item>
            <!----------------------------------------------------------------------------------------------->
            <dxi-item
                [ratio]="0.0040" 
            >  
    
            </dxi-item>
            <!----------------------------------------------------------------------------------------------->
            <dxi-item
                [ratio]="1.0"
            >   

                <dx-box
                    direction="col"
                    width="100%"
                    height="100%"
                >

                    <dxi-item
                        [ratio]="8"
                    >

                        <dx-data-grid 
                            #grideventinvitee
                            id="grideventinvitee"

                            keyExpr="id"
                            [dataSource]="subscriptioninviteelist"  
                            noDataText="No Invitee Listed"     

                            [allowColumnReordering]="false"
                            [allowColumnResizing]="true"
                            [showRowLines]="true"
                            [showColumnLines]="false"
                            [showBorders]="true"
                            [repaintChangesOnly]="true"

                            [focusedRowEnabled]="true"
                            [hoverStateEnabled]="true"
                            [autoNavigateToFocusedRow]="true"

                            (onRowClick)="inviteeclick($event)"

                            width="100%"
                            height="100%"
                        >

                            <dxo-filter-row
                                [visible]="true"
                            >
                            </dxo-filter-row>

                            <dxo-sorting
                                mode="single"> <!-- or "multiple" | "none" -->
                            </dxo-sorting>

                            <dxo-selection
                                mode="single"
                            >
                            </dxo-selection>

                            <dxo-load-panel
                                [enabled]="false">
                            </dxo-load-panel>

                            <dxo-editing 
                                mode="popup"                            
                                [allowUpdating]="false"
                                [allowDeleting]="false"
                                [allowAdding]="false"
                                [useIcons]="false"
                            >
                            </dxo-editing>
                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                            <dxi-column
                                dataField="id"
                                caption="id"
                                [allowEditing]="false" 
                                [allowSorting]="false"
                                [visible]="false"
                                width="19%"
                            >
                            </dxi-column>   

                            <dxi-column
                                dataField="whoseparticipant"
                                caption="Whose Guest"
                                [allowEditing]="true" 
                                [allowSorting]="false"
                                [allowFiltering]="false"
                                [visible]="true"
                                width="19%"

                                groupCellTemplate="cellparticipantname"
                                [groupIndex]="0"
                            >

                                <dxi-validation-rule 
                                    type="required"
                                    message="Whose Guest">
                                </dxi-validation-rule>

                                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->    
                                <div *dxTemplate="let d of 'cellparticipantname'">
                                    <div>{{whoseguest | getinitial: d.value: whoseguest.length: 10 }}</div> 
                                </div>  
                                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 

                            </dxi-column>
                            
                            <dxi-column
                                dataField="title"
                                caption="Title"
                                [allowEditing]="false" 
                                [allowSorting]="false"
                                [visible]="true"
                                width="19%"
                            >

                            </dxi-column>   

                            <dxi-column
                                dataField="lastname"
                                caption="Last Name"
                                [allowEditing]="true" 
                                [allowSorting]="false"
                                [visible]="true"
                                width="19%"
                            >

                            </dxi-column>

                            <dxi-column
                                dataField="firstname"
                                caption="First Name"
                                [allowEditing]="true" 
                                [allowSorting]="false"
                                [visible]="true"
                                width="19%"
                            >

                            </dxi-column>
                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                        </dx-data-grid>

                    </dxi-item>
                    <!----------------------------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="0.10"
                    >
                    </dxi-item>
                    <!----------------------------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="3.5"
                    >

                        <dx-box
                            direction="row"
                            width="100%"
                            height="100%"
                        >

                            <dxi-item
                                [ratio]="7"
                            >
                                
                                <dx-box
                                    direction="col"
                                    width="100%"
                                    height="100%"
                                >
                                
                                    <!----------------------------------------------------------------------------------------------->
                                    <dxi-item
                                        class="rectangleinfosquare"
                                        [ratio]="8"
                
                                    > 
                                        <dx-text-area
                                            label="Street Address"

                                            [(value)]="selstreet"
                                            
                                            [autoResizeEnabled]="false"
                                            width="98%"
                                            height="95%"
                                            [readOnly]="true"
                                        >   
                                        </dx-text-area>

                                    </dxi-item>
                                    <!----------------------------------------------------------------------------------------------->
                                    <dxi-item
                                        [ratio]="0.250"
                                    >
                                    </dxi-item>
                                    <!----------------------------------------------------------------------------------------------->
                                    <dxi-item
                                        class="rectangleinfosquare"
                                        [ratio]="5"
                                    > 
                                        <!----------------------------------------------------------------------------------------------->
                                        <div style="display: flex;column-gap: 5px">

                                                <dx-text-box
                                                    label="Phone"
                                                    stylingMode="outlined"
                                                    labelMode="static"
                                                    [readOnly]="true"

                                                    height="98%"
                                                    width="48%"
                                        
                                                    [inputAttr]="{ 'class': 'fontsize12'  }"

                                                    [value]="selphone"
                                                >
                                                </dx-text-box>
                                            
                                                <dx-text-box
                                                    label="Mobile"
                                                    stylingMode="outlined"
                                                    labelMode="static"
                                                    [readOnly]="true"

                                                    height="98%"
                                                    width="48%"
                                        
                                                    [inputAttr]="{ 'class': 'fontsize12'  }"

                                                    [value]="selmobile"
                                                >
                                                </dx-text-box>
                                            
                                        </div>

                                    </dxi-item>
                                    <!----------------------------------------------------------------------------------------------->       
                                    <dxi-item
                                        [ratio]="0.250"
                                    >
                                    </dxi-item>
                                    <!----------------------------------------------------------------------------------------------->
                                    <dxi-item
                                        class="rectangleinfosquare"
                                        [ratio]="5"
                
                                    > 
                                        <dx-text-box
                                            label="Email"
                                            stylingMode="outlined"
                                            labelMode="static"
                                            [readOnly]="true"

                                            height="95%"
                                            width="98%"
                                
                                            [inputAttr]="{ 'class': 'fontsize12'  }"

                                            [value]="selemail"
                                        >
                                        </dx-text-box>

                                    </dxi-item>
                                    <!----------------------------------------------------------------------------------------------->
                                </dx-box>

                            </dxi-item>
                            <!----------------------------------------------------------------------------------------------->
                            <dxi-item
                                [ratio]="0.05" 
                            >  
                            </dxi-item>
                            <!----------------------------------------------------------------------------------------------->
                            <dxi-item
                                class="rectangleinfosquare"
                                [ratio]="5"
                            >
                                <!----------------------------------------------------------------------------------------------->
                                <div ngSwitch="{{barseriestag}}">

                                    <!----------------------------------------------------------------------------------------------->
                                    <div *ngSwitchCase = 35>


                                        <dx-text-area
                                            label="Invitation Delivery Point for person(s) below"
                                            stylingMode="outlined"
                                            labelMode="static"

                                            [(value)]="invitationdeliverypoint"

                                            [autoResizeEnabled]="false"

                                            [inputAttr]="{ 'class': 'fontsize10'  }"

                                            width="98%"
                                            height="40%"
                                            [readOnly]="true"
                                        >   
                                        </dx-text-area>

                                        <dx-list
                                            #inviteelist
                                            id="inviteelist"
        
                                            [items]="returninviteelist1"
        
                                            height="98%"
                                        >
                                            <div *dxTemplate="let item of 'item'">
                                                <div>
                                                    <span class="fontsize10">&nbsp;&nbsp;{{item | extractinviteename:1 }}</span>
                                                </div> 
                                            </div>
        
                                        </dx-list>

                                    </div>
                                    <!----------------------------------------------------------------------------------------------->
                                    <div *ngSwitchCase = 50>

                                        Seating



                                    </div>
                                    <!----------------------------------------------------------------------------------------------->
                                    <div *ngSwitchCase = 65>

                                        Thankyou Notes



                                    </div>
                                    <!----------------------------------------------------------------------------------------------->
                                    <div *ngSwitchDefault>



                                    </div>
                                    <!----------------------------------------------------------------------------------------------->
                                </div>
                                <!----------------------------------------------------------------------------------------------->
                               
                            </dxi-item>

                        </dx-box>

                    </dxi-item>
                    <!----------------------------------------------------------------------------------------------->
                </dx-box>
                
            </dxi-item>
            <!----------------------------------------------------------------------------------------------->

        </dx-box>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    </body>

</html>
